import React from 'react';
import { Button, Message } from '../../../../ds';
import DropZone from './DropZone';
import PropTypes from 'prop-types';
import './uploadFile.scss';

const UploadFile = ({ onChange, onDownload }) => {
  return (
    <>
      <div className='k-ds-heading-05'>Adjuntar plantilla</div>
      <div className='k-ds-body-02 k-ds-m-top-sp-06'>
        Adjunta o arrastra el archivo en <strong>formato .xlsx</strong> (máximo
        100 transacciones por plantilla).
      </div>
      <Message
        type='information'
        className='k-ds-m-bottom-sp-05 k-ds-m-top-sp-05 upload-file-message'
        message={
          <div className='k-ds-heading-01'>
            Para convertir el documento de Excel al formato de la plantilla,
            selecciona Archivo, Descargar, Microsoft Excel (.xlsx).
          </div>
        }
      />
      <DropZone onFilesChange={onChange} />
      <div className='k-ds-body-02 download-cancellation-template'>
        Puedes
        <Button
          type='link'
          className='download-cancellation-template-link'
          onClick={onDownload}
        >
          descargar
        </Button>
        la plantilla si no la tienes
      </div>
    </>
  );
};

UploadFile.propTypes = {
  onChange: PropTypes.func,
  onDownload: PropTypes.func,
};

export default UploadFile;
